<template>
  <div class="inbox col-md-3" role="navigation" aria-label="Email navication" id="inboxList">
    <a class="skip-to" href="#mail-view">Skip inbox</a>
    <div ref="heading" class="text-center col-md-12 inbox-toolbar">
      <b class="mr-10">Filter by: </b>
      <div class="btn-group text-center" role="group" aria-label="Filter Emails">
        <button
          @click="currentFilter = 'all'"
          class="btn btn-default"
          :class="{ active: currentFilter === 'all' }"
        >
          All
        </button>
        <button
          @click="currentFilter = 'flaggedEmails'"
          class="btn btn-default"
          :class="{ active: currentFilter === 'flaggedEmails' }"
        >
          Flagged
        </button>
      </div>
    </div>
    <div ref="mailWrapper" class="emails-wrapper" data-testid="email-list">
      <template v-if="!emailsFromSelectedFolder.length && activeFolder === 'answeredEmails'">
        <h4 class="text-center mt-20">There are no emails in the Sent Mail folder.</h4>
        <div class="text-center mt-20">A fresh start!</div>
      </template>
      <template v-else>
        <transition-group name="list" tag="div">
          <template v-if="assessmentType.isRehearsal">
            <template v-for="(email, idx) in filteredActiveList">
              <inboxItem
                v-on:selected="selectEmail"
                v-if="idx == 0"
                data-container="body"
                data-toggle="popover"
                data-trigger="manual"
                data-placement="right"
                :data-content="popoverText"
                :email="email"
                :class="{ selected: isActive(email) }"
                :key="email.questionKey"
                data-testid="inbox-item"
              >
              </inboxItem>
              <inboxItem
                v-else
                v-on:selected="selectEmail"
                :email="email"
                :class="{ selected: isActive(email) }"
                :key="email.questionKey"
              >
              </inboxItem>
            </template>
          </template>
          <template v-else>
            <inboxItem
              v-for="email in filteredActiveList"
              v-on:selected="selectEmail"
              :email="email"
              :class="{ selected: isActive(email) }"
              :key="email.questionKey"
            >
            </inboxItem>
          </template>
        </transition-group>
      </template>
    </div>
  </div>
</template>
<script>
  import InboxItem from './InboxItem.vue';
  import { mapGetters } from 'vuex';

  export default {
    name: 'inbox',

    data() {
      return {
        selectedEmail: undefined,
        currentFilter: 'all',
        activeFolder: 'deliveredEmails',
        popoverText: 'Select the first email to learn more about the assessment interface.',
      };
    },

    components: {
      InboxItem,
    },

    computed: {
      ...mapGetters(['showTimerAsClock']),
      ...mapGetters('email', [
        'cleanEmails',
        'unansweredEmails',
        'answeredEmails',
        'deliveredEmails',
      ]),

      ...mapGetters(['assessmentType']),

      activeList() {
        // The number should be higher than 1000ms - 1s in order to start displaying emails
        // Leave this line for the future sprint (where expired timer will hide all active emails so user won't be able to engage when expired)
        // if (this.$store.state.time.total < 1000) return [];
        return this.activeFolder === 'answeredEmails'
          ? this.answeredEmails
          : this.deliveredEmails.filter((email) => {
              if (email.isSmartThreading) {
                return !email.isSent && email.isActive;
              }
              return !email.isSent;
            });
      },

      filteredActiveList: (vm) =>
        vm.currentFilter === 'flaggedEmails'
          ? vm.activeList.filter((email) => email.isFlagged)
          : vm.activeList,

      emailsFromSelectedFolder() {
        let activeFolder = this[this.activeFolder];
        return activeFolder;
      },
    },

    methods: {
      selectEmail(email) {
        // Removes popover for rehearsal
        if (this.assessmentType.isRehearsal) {
          let firstEmail = this.emailsFromSelectedFolder.indexOf(email);
          if (!firstEmail) $('[data-toggle="popover"]').popover('hide');
        }
        this.selectedEmail = email;
        this.$emit('selectEmail', email);
      },

      isActive(email) {
        return this.selectedEmail == email;
      },

      resize() {
        this.$el.style.height = `${window.innerHeight - 50}px`;
        if (this.$refs.mailWrapper)
          this.$refs.mailWrapper.style.height = `${
            this.$el.offsetHeight - this.$refs.heading.offsetHeight - 5
          }px`;
      },
    },

    watch: {
      activeFolder() {
        this.currentFilter = 'all';
      },
    },

    mounted() {
      $(window).on('resize', () => this.resize());
      EventBus.$on('showFolder', (filter) => (this.activeFolder = filter));
      this.$nextTick(() => this.resize());
    },
  };
</script>
<style lang="scss">
  .list-enter-active,
  .list-leave-active {
    transition: all 0.5s;
  }
  .list-enter /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(-100px);
  }

  .list-leave-to {
    opacity: 0;
    transform: translateX(-200px);
  }

  .inbox {
    height: 100%;
    background-color: white;

    .emails-wrapper {
      overflow-y: auto;
      margin: auto -15px;
      padding: 0 15px;
      border-top: 1px solid #dadadc;
      background: #dbdbdb;

      & > div {
        display: flex;
        flex-direction: column-reverse;
      }
    }

    .inbox-toolbar {
      line-height: 60px;
      color: black;
      display: inline-block;

      .btn:focus {
        outline: none;
      }
    }
  }
</style>
